import styled from 'styled-components';

export const StyledDynamicTabbedLayout = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: auto;

  @media screen and (max-width: 576px) {
    & .container {
      max-width: 100vw;
    }
  }
`;
